// extracted by mini-css-extract-plugin
export default {"container":"styles_container__Br+3A","loading":"styles_loading__ri719"};